<template>
    <div class="account-info-box box">
        <div class="box-title">
            <slot name="title" />
        </div>
        <p
            v-if="error"
            class="error"
        >
            Something went wrong. Please try again or <a href="mailto:help@fusebox.fm">contact us</a>
        </p>
        <template v-else>
            <div class="box-content">
                <template v-for="(control, key) in controls">
                    <question
                        :key="key"
                        :control="control"
                        :user-meta="userMeta"
                    />
                </template>
                <div class="controll-container flex">
                    <base-submit-button
                        class="btn"
                        :loading="saving"
                        @click="saveMeta"
                    >
                        Save Changes
                    </base-submit-button>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import Question from './Question.vue';

import { mapActions } from 'vuex';
import toasts from '@/mixins/toasts';

export default {
    components: {
        Question,
    },
    mixins: [toasts],
    props: {
        error: {
            type: Boolean,
        },
        controls: {
            type: Array,
            default: () => [],
        },
        userMeta: {
            type: Object,
            default: () => ({}),
        },
        allControls: {
            type: Array,
            default: () => [],
        },
    },

    /**
     *
     * @returns {object} Component data
     */
    data() {
        return {
            saving: false,
        };
    },
    methods: {
        ...mapActions(['setUserMeta']),

        /**
         * Saves user meta
         *
         */
        saveMeta() {
            const preparedMeta = this.prepareMeta();

            this.saving = true;

            this.setUserMeta(preparedMeta)
                .then(() => {
                    this.toastSuccess({
                        message: {
                            title: 'Your profile has been saved',
                        },
                    });

                    this.saving = false;
                })
                .catch(() => {
                    this.toastError({
                        message: {
                            title: 'An error occured, please try again later',
                        },
                    });

                    this.saving = false;
                });
        },

        /**
         * Removes empty meta keys
         *
         * @returns  {object}  User meta.
         */
        prepareMeta() {
            const metaKeys = this.userMeta;
            const controlKeys = this.allControls.map((control) => {
                return control.name;
            });

            Object.keys(metaKeys).forEach((key) => {
                if (controlKeys.includes(key) && '' === metaKeys[key]) {
                    delete metaKeys[key];
                }
            });

            return metaKeys;
        },
    },
};
</script>
